// Primary site navigation — single source of truth for header + footer.
// Top-level items may have `children` (rendered as an accessible dropdown on
// desktop and an accordion in the mobile sheet). Additional top-level menus
// will be appended here as the sitemap is finalized.

export const PRIMARY_NAV = [
  {
    id: "who-we-are",
    label: "Who We Are",
    href: "/about",
    testid: "nav-who-we-are",
    labelOnly: true,
    children: [
      {
        id: "about",
        label: "About World Farmers",
        href: "/about",
        description: "Our mission and the Flats Mentor Farm",
      },
      {
        id: "history",
        label: "Our History",
        href: "/history",
        description: "Four decades of growing farmers since 1984",
      },
      {
        id: "impact",
        label: "Impact",
        href: "/impact",
        description: "Our results by the numbers and annual reports",
      },
      {
        id: "team",
        label: "Meet the Team",
        href: "/who-we-are",
        description: "The staff and board behind the fields",
      },
      {
        id: "farmers",
        label: "Meet the Farmers",
        href: "/meet-the-farmers",
        description: "Stories from the growers at the Flats",
      },
      {
        id: "media",
        label: "Media",
        href: "/media",
        description: "In the news, announcements, and blog",
      },
    ],
  },
  {
    id: "programs",
    label: "Programs & Services",
    href: "/programs",
    testid: "nav-programs",
    children: [
      {
        id: "flats-mentor-farm",
        label: "Flats Mentor Farm",
        href: "/programs/flats-mentor-farm",
        description: "Land, infrastructure, and training in Lancaster, MA",
      },
      {
        id: "mentorship",
        label: "Mentorship/Internship",
        href: "/programs/mentorship",
        description: "A five-phase path to farm independence",
      },
      {
        id: "landsites",
        label: "Program Landsites",
        href: "/program-landsites",
        description: "Where our farmers grow across Massachusetts",
      },
    ],
  },
  {
    id: "where-to-buy",
    label: "Where to Buy",
    href: "/where-to-buy",
    testid: "nav-where-to-buy",
    children: [
      {
        id: "farmers-markets",
        label: "Farmers Markets",
        href: "/farmers-markets",
        description: "19 farmers\u2019 markets across Massachusetts",
      },
      {
        id: "csa",
        label: "CSA Sign-Up",
        href: "/csa",
        description: "16 weeks of fresh shares, July through October",
      },
      {
        id: "wholesale",
        label: "Wholesale & Farm Products",
        href: "/wholesale",
        description: "For grocers, food hubs, restaurants, and institutions",
      },
      {
        id: "crops",
        label: "Crops & Other Farm Products",
        href: "/crops",
        description: "Explore 80+ crops grown at the Flats",
      },
    ],
  },
  {
    id: "get-involved",
    label: "Get Involved",
    href: "/get-involved",
    testid: "nav-get-involved",
    labelOnly: true,
    children: [
      {
        id: "donate",
        label: "Donate",
        href: "/support",
        description: "Fund land, training, and market access for farmers",
      },
      {
        id: "contact",
        label: "Contact Us",
        href: "/contact",
        description: "Reach the team or join our email list",
      },
      {
        id: "events",
        label: "Events",
        href: "/events",
        description: "Tour de Farm and other gatherings at the Flats",
      },
      {
        id: "work-with-us",
        label: "Work With Us",
        href: "/work-with-us",
        description: "Job openings and partnership opportunities",
      },
    ],
  },
];

// Footer utility links (kept separate from the sitemap).
export const FOOTER_UTILITY_LINKS = [
  { id: "admin", label: "Staff Login", href: "/admin" },
  { id: "farmer-portal", label: "Farmer Log In", href: "/farmer-portal" },
];

// Header action links shown next to the Donate button.
export const HEADER_ACTIONS = [
  { id: "farmer-login", label: "Farmer Log In", href: "/farmer-portal", testid: "header-farmer-login-link" },
];
